<template>
  <div>
    <iframe style="width:100%;height:500px" :src="url" title="SoftlineAngola"></iframe>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import impressaoService from '../../services/impressaoService'
const ls = require('local-storage')

export default {
  data: () => ({
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hash: ls.get('hashFactura'),
    hora: '',
    config: null,
    baseUrl: '',
    itemsDaFactura: ls.get('itemsFatura'),
    infoFactura: ls.get('itemsFaturaEstaticos'),
    clienteData: null,
    url: ''
  }),

  async created() {    
    this.definirDataHora()
    await this.getSoftlineConfi()
    await this.getClienteConfig()
    await this.getUrlImpressao()
  },

  methods: {
    definirDataHora() {
      const data = new Date()
      const dia = String(data.getDate()).padStart(2, '0')
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const ano = data.getFullYear()
      const hora = String(data.getHours()).padStart(2, '0')
      const minutos = String(data.getMinutes()).padStart(2, '0')
      const segundos = String(data.getSeconds()).padStart(2, '0')

      this.mes_ano = `${ano}${mes}`
      this.data_actual = `${dia}/${mes}/${ano}`
      this.hora = `${hora}:${minutos}:${segundos}`
      this.dataHora = `${dia}-${mes}-${ano} ${this.hora}`
    },

    async getSoftlineConfi() {
      try {
        const res = await axios.get('/infoDetalhesSoftline')
        this.config = res.data[0]
        if (!this.config) {
          Swal.fire('Informação', 'Informação da empresa não encontrada!', 'info')
        }
      } catch (error) {
        console.error('Erro ao obter configuração da empresa:', error)
      }
    },

    async getClienteConfig() {
      try {
        const res = await axios.get(`/infoClienteConfig/${this.infoFactura.nif}`)
        this.clienteData = res.data[0]
        if (!this.clienteData) {
          Swal.fire('Informação', 'Informação do cliente não encontrada', 'info')
        }
      } catch (error) {
        console.error('Erro ao obter dados do cliente:', error)
      }
    },

    async getUrlImpressao() {
      try {
        const res = await impressaoService.getBaseUrl()
        this.baseUrl = res.data[0].url
      } catch (error) {
        console.error('Erro ao obter URL de impressão:', error)
      } finally {
        this.comporHtml()
      }
    },

    async comporHtml() {
      try {
        const res = await axios.get('/obterRelatorioByDescricao/nc')
        const templateFull = res.data[0]

        if (!templateFull) {
          Swal.fire('Informação', 'Documento não configurado', 'info')
          return
        }

        let template = templateFull.documento
        let produtoFactura = ''
        let totalIva = 0
        let i = 1

        this.itemsDaFactura.forEach(element => {
          let linha = templateFull.documentoiteracao1
            .replace('{{indexFactura}}', i++)
            .replace('{{descricaoFactura}}', element.produto)
            .replace('{{qtdFactura}}', element.qtd_venda)
            .replace('{{pUnitFactura}}', utilitarios.IntegerToMoneyValueFatura(element.precoUnitario))
            .replace('{{ivaFactura}}', utilitarios.IntegerToMoneyValueFatura(element.iva))
            .replace('{{descFactura}}', utilitarios.IntegerToMoneyValueFatura(element.descontoLinha))
            .replace('{{totalFactura}}', utilitarios.IntegerToMoneyValueFatura(element.subTotal))

          totalIva += element.iva
          produtoFactura += linha
        })

        const dados = {
          '{{logo}}': this.config.logo,
          '{{empresaEndereco}}': this.config.endereco,
          '{{empresaTlfn}}': this.config.tlf,
          '{{empresaEmail}}': this.config.email,
          '{{empresaNif}}': this.config.contribuente,
          '{{numeroFactura}}': this.infoFactura.numeroDocumento,
          '{{motivo}}': this.infoFactura.motivo_anulacao,
          '{{factura_anulada}}': this.infoFactura.factura_anulada,
          '{{nomeCliente}}': this.clienteData.nome,
          '{{clienteAdress}}': this.clienteData.endereco,
          '{{clienteNif}}': this.infoFactura.nif,
          '{{clienteTel}}': this.clienteData.telefone,
          '{{clienteEmail}}': this.clienteData.email,
          '{{dataVenda}}': this.infoFactura.data_,
          '{{ItemsFactura}}': produtoFactura,
          '{{iliquidoFactura}}': utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorIliquido),
          '{{totalIva}}': utilitarios.IntegerToMoneyValueFatura(totalIva),
          '{{totalGeral}}': utilitarios.IntegerToMoneyValueFatura(this.infoFactura.valorAPagar),
          '{{retencaoFonte}}': '0,00',
          '{{nomeEmpresa}}': this.config.nome,
          '{{empresaBanco}}': this.config.banco,
          '{{empresaMoeda}}': this.config.moeda,
          '{{empresaNumConta}}': this.config.numConta,
          '{{empresaIban}}': this.config.iban,
          '{{nomeOperador}}': this.infoFactura.nomeUsuario,
          '{{numeroSoftwareAGT}}': '519/AGT/2025',
          '{{hashSaft}}': this.hash,
          '{{valorExtensoFactura}}': utilitarios.ObterValorPorExtensao(this.infoFactura.valorAPagar),
        }

        const regex = new RegExp(Object.keys(dados).join('|'), 'g')
        template = template.replace(regex, match => dados[match])

        const options = {
          format: 'A4',
          orientation: 'portrait',
          border: { right: '5mm', left: '5mm' },
          header: { height: '5mm' },
          footer: { height: '5mm' }
        }

        impressaoService.htmlToPdf(template, options)
      } catch (error) {
        console.error('Erro ao compor HTML:', error)
        this.$store.state.loading_pdf = false
      }
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
</style>
